module.exports = __webpack_public_path__ + "img/spartan-roof-replacement-waterproofing-06-xxlarge.f62b2948.jpg";